import {useEffect, useState} from "react"
import {SmartKodiMap, createMarkers} from "../../components/map"
import {ResponsiveRow} from "../../constants/layout.constants"
import ExploreListing from "../../components/cards/listings/exploreListing"
import LandingExploreBar from "../../components/modules/listings/landingExploreBar"
import {useSelector} from "react-redux"
import {getListingsSecure, getListingsUnsecure,} from "../../services/listingsServices/listing.service"
import {loadListingTypes, loadPropertyTypes,} from "../../services/listingsServices/list.service"
import { useLocation, useNavigate } from "react-router-dom"
import { CircularProgress, Typography } from "@mui/material"
import { isNullUndefined } from "../../util/util"
import { isEmptyObject } from "jquery"

export default function ListingExplore() {
    const navigate = useNavigate()
    const location = useLocation()
    const isLoggedIn = useSelector((state) => state?.auth?.isLoggedIn)
    const [listings, setListings] = useState([])
    const [filteredListings, setFilteredListings] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [center, setCenter] = useState({})
    const [pageNo] = useState(0)
    const [filterByPropertyName] = useState("")
    const [listingTypes, setListingTypes] = useState([])
    const [propertyTypes, setPropertyTypes] = useState([])
    const [selectedPropertyType, setSelectedPropertyType] = useState(location?.state?.propertyType ?? "")
    const [selectedListingType, setSelectedListingType] = useState("")
    const [noOfBeds, setNoOfBeds] = useState("")
    const [noOfBaths, setNoOfBaths] = useState("")
    const [sqftMin, setSqftMin] = useState("")
    const [sqftMax, setSqftMax] = useState("")
    const [priceMin, setPriceMin] = useState(location?.state?.budget?.min ?? 0)
    const [priceMax, setPriceMax] = useState(location?.state?.budget?.max ?? 10000000000)
    const [openFilterModal, setOpenFilterModal] = useState(false)
    const [listingMarkers, setListingMarkers] = useState([])
    const [reLocate, setReLocate] = useState(false)
    const [locationName,] = useState(location?.state?.locationName ?? "")
    const [bounds, setBounds] = useState({})

    useEffect(() => {
        if (openFilterModal || (locationName && isEmptyObject(bounds))) return;

        let isCurrent = true;
        setIsLoading(true);

        const data = {
            propertyType: selectedPropertyType,
            listingType: selectedListingType,
            name: filterByPropertyName,
            noOfBeds,
            noOfBaths,
            sqftMin,
            sqftMax,
            priceMin,
            priceMax,
            pageNo,
            rowsPerPage: 12,
            bounds
        };

        if (isEmptyObject(bounds)) return;

        const fetchListings = (isLoggedIn ? getListingsSecure : getListingsUnsecure)(data);

        fetchListings.then(data => {
            if (isCurrent) {
                setListings(data);
                setFilteredListings(data);
            }
        }).catch(() => {
            if (isCurrent) setIsLoading(false);
        }).finally(() => {
            if (isCurrent) setIsLoading(false);
        });

        return () => {
            isCurrent = false;
        };
    }, [isLoggedIn, location.state, bounds])

    useEffect(() => {
        navigator.geolocation.getCurrentPosition(success, error)
        loadListingTypes()
            .then((data) => setListingTypes(data))
            .catch((error) => {
                console.error("loadListingTypes Error: ", error)
            })
        loadPropertyTypes()
            .then((data) => setPropertyTypes(data))
            .catch((error) => {
                console.error("loadPropertyTypes Error: ", error)
            })
    }, [reLocate])

    useEffect(() => {
        createMarkers(setListingMarkers, listings)
    }, [listings]);

    function handleFilterModal() {
        setOpenFilterModal(!openFilterModal)
    }

    function clearFilter() {
        setSelectedPropertyType("")
        setSelectedListingType("")
        setNoOfBaths("")
        setNoOfBeds("")
        setSqftMin("")
        setSqftMax("")
        setPriceMin("")
        setPriceMax("")
    }

    function success(pos) {
        const crd = pos.coords
        setCenter({lat: crd.latitude, lng: crd.longitude})
        setReLocate(false)
    }

    function error(err) {
        console.warn(`ERROR(${err.code}): ${err.message}`)
    }

    function applyFilterClicked() {
        setOpenFilterModal(false)
        const data = {
            propertyType: selectedPropertyType,
            listingType: selectedListingType,
            name: filterByPropertyName,
            noOfBeds: noOfBeds,
            noOfBaths: noOfBaths,
            sqftMin: sqftMin,
            sqftMax: sqftMax,
            priceMin: priceMin,
            priceMax: priceMax,
            pageNo: pageNo,
            rowsPerPage: 12,
            bounds: bounds
        }
        !isLoggedIn
            ? getListingsUnsecure(data)
                .then((data) => {
                    setListings(data)
                    setFilteredListings(data)
                })
            : getListingsSecure(data)
                .then((data) => {
                    setListings(data)
                    setFilteredListings(data)
                })
    }

    function onPropertyTypeChange(event) {
        let value = event.target.value
        setSelectedPropertyType(value)
    }

    function onListingTypeChange(event) {
        let value = event.target.value
        setSelectedListingType(value)
    }

    function noOfBedsChanged(event) {
        let value = event.target.value
        setNoOfBeds(value)
    }

    function noOfBathsChanged(event) {
        let value = event.target.value
        setNoOfBaths(value)
    }

    function sqftMinChanged(event) {
        let value = event.target.value
        setSqftMin(value)
    }

    function sqftMaxChanged(event) {
        let value = event.target.value
        setSqftMax(value)
    }

    function priceMinChanged(event) {
        let value = event.target.value
        setPriceMin(value)
    }

    function priceMaxChanged(event) {
        let value = event.target.value
        setPriceMax(value)
    }

    function listingSelected(item) {
        navigate("/listings/view/" + item.id)
    }

    return (
        <ResponsiveRow sx={{flexDirection: "column", height: "100%", padding: 0}}>
                <ResponsiveRow
                    container
                    sx={{
                        width: "100%",
                        textAlign: "start",
                        padding: 0,
                        maxHeight: {xs: "100%", lg: "85vh"},
                        overflowY: {xs: "auto", lg: "hidden"},
                    }}
                >
                    <ResponsiveRow
                        item
                        sx={{
                            display: {xs: "none", lg: "flex"},
                            width: {xs: "100%", lg: "60%"},
                            height: {xs: "100%", lg: "87vh"},
                            padding: 0,
                        }}
                    >
                        <SmartKodiMap
                            view={"listings"}
                            containerStyle={{width: "100%", height: "100%"}}
                            center={center}
                            children={listingMarkers}
                            listingCollection={listings}
                            setFilteredListings={setFilteredListings}
                            zoom={15}
                            setIsLoading={setIsLoading}
                            setBounds={setBounds}
                        />
                    </ResponsiveRow>
                    <ResponsiveRow
                        item
                        sx={{
                            width: {xs: "100%", lg: "40%"},
                            height: {xs: "100%", lg: "85vh"},
                            padding: 0,
                            margin: 0,
                            marginBottom: "0px",
                            justifyContent: "center",
                        }}
                    >
                        <LandingExploreBar
                            noOfBedsChanged={noOfBedsChanged}
                            noOfBathsChanged={noOfBathsChanged}
                            sqftMinChanged={sqftMinChanged}
                            sqftMaxChanged={sqftMaxChanged}
                            priceMinChanged={priceMinChanged}
                            priceMaxChanged={priceMaxChanged}
                            onPropertyTypeChange={onPropertyTypeChange}
                            onListingTypeChange={onListingTypeChange}
                            listingTypes={listingTypes}
                            propertyTypes={propertyTypes}
                            noOfBeds={noOfBeds}
                            noOfBaths={noOfBaths}
                            sqftMin={sqftMin}
                            sqftMax={sqftMax}
                            priceMin={priceMin}
                            priceMax={priceMax}
                            selectedPropertyType={selectedPropertyType}
                            selectedListingType={selectedListingType}
                            applyFilterClicked={applyFilterClicked}
                            handleFilterModal={handleFilterModal}
                            openFilterModal={openFilterModal}
                            clearFilter={clearFilter}
                            setCenter={setCenter}
                            setReLocate={setReLocate}
                            searchedLocation={locationName}
                            setBounds={setBounds}
                        />
                        <ResponsiveRow
                            sx={{
                                height: "70%",
                                padding: "0 20px",
                                justifyContent: "center",
                                alignItems: "flex-start",
                                overflowY: "auto",
                                marginBottom: "30px",
                            }}
                        >
                            
                            {isLoading ? (
                                <CircularProgress size={50}>Loading...</CircularProgress>
                            ) : (!isLoading && !isNullUndefined(filteredListings) && filteredListings.length > 0) ? (
                                filteredListings.map((item, i) => (
                                    <ExploreListing
                                        key={i}
                                        listing={item}
                                        listingSelected={listingSelected}
                                    />
                                ))
                            ) : (
                                <Typography variant="h5" sx={{margin: "30px 20px"}}>
                                    No listings found
                                </Typography>
                            )}
                        </ResponsiveRow>
                    </ResponsiveRow>
                </ResponsiveRow>
        </ResponsiveRow>
    )
}
